// Dependencias
import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';

/**
 *
 * @param error
 * @returns
 */
export function httpTokenInterceptor(error: AxiosError) {
  const isUnauthorizedError = error.response?.status === StatusCodes.UNAUTHORIZED;
  if (isUnauthorizedError) {
    window.location.reload();

    return Promise.reject(error);
  }

  return Promise.reject(error);
}
